// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ud0F","title":"Header_title__3xs6a","left":"Header_left__2YNSD","clinicName":"Header_clinicName__19N8k"};